import { useMutation } from '@tanstack/react-query';
import JSZip from 'jszip';
// @ts-ignore
import { saveAs } from 'file-saver';
import { useCustomizationV4Query } from '@modules/Dashboard/Product/hooks/useCustomizationV4Query';
import { useToastsContext } from '@fourthwall/components';
const useDownloadZip = (customizationId) => {
    const { notify } = useToastsContext();
    const { customizationV4Query } = useCustomizationV4Query([customizationId]);
    const links = customizationV4Query.data?.manufacturerFiles.map((file) => file.original);
    const downloadZipMutation = useMutation(async () => {
        const zip = new JSZip();
        if (!links) {
            throw new Error('useDownloadZip :: No links provided');
        }
        // Fetch all files concurrently
        const files = await Promise.all(links.map(async (link) => {
            try {
                const response = await fetch(link.uri);
                if (!response.ok)
                    throw new Error(`Failed to fetch ${link.uri}`);
                const blob = await response.blob();
                const sizeName = link.tags.map((tag) => `${tag.name}_${tag.value}`).join('_');
                const fileName = sizeName.length > 0 ? `${sizeName}.jpg` : 'artworkFile.jpg';
                return { fileName, blob };
            }
            catch (error) {
                notify(`Error fetching file ${link}`, { type: 'error' });
                throw error; // Ensures Promise.all fails on errors
            }
        }));
        files.forEach(({ fileName, blob }) => {
            zip.file(fileName, blob);
        });
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'artwork_files.zip');
    });
    return {
        downloadZip: downloadZipMutation.mutateAsync,
        isProcessing: downloadZipMutation.isLoading,
    };
};
export default useDownloadZip;
